import { useQuery } from '@apollo/client'

import { gql } from '@/clients/utoniq-core'
import {
  ConsoleCampaignsConnectionFragmentDoc,
  ConsoleCampaignsQuery,
  ConsoleCampaignsQueryVariables,
} from '@/clients/utoniq-core/schema'
import { useCurrentUser } from '@/core'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()

  const { data, loading, fetchMore } = useQuery<
    ConsoleCampaignsQuery,
    ConsoleCampaignsQueryVariables
  >(QUERY, {
    variables: {
      excludeExpired: false,
    },
  })

  return {
    state: {
      artistId: user?.uid ?? '',
      loading: loading,
      artist: data?.artist ?? null,
      hasNextPage: !!data?.campaigns?.pageInfo.hasNextPage,
      campaigns: data?.campaigns ?? null,
      currentUser: user,
      membership: data?.artist?.subscription?.products ?? undefined,
    },
    actions: {
      onFetchMore: async () => {
        await fetchMore({
          variables: {
            campaignsPageInput: {
              cursor: data?.campaigns?.pageInfo.endCursor,
            },
          },
        })
      },
    },
  }
})

const QUERY = gql`
  query ConsoleCampaigns(
    $excludeExpired: Boolean
    $campaignsPageInput: PageInput
  ) {
    campaigns(excludeExpired: $excludeExpired, pageInput: $campaignsPageInput) {
      ...ConsoleCampaignsConnection
    }
    artist {
      id
      paymentType
      hasArrangingDeliveryItems
      subscription {
        products {
          productId
        }
      }
    }
  }
  ${ConsoleCampaignsConnectionFragmentDoc}
`
